<script lang="ts">
  import { fly, fade } from 'svelte/transition';
  import { flip } from 'svelte/animate';
  import { CircleCheck, CircleAlert, Info, TriangleAlert, X } from '@lucide/svelte';
  import { toast } from '../toast.svelte';
  import '../messages/ui';
  import { t } from '../i18n.svelte';
  const icons = { success: CircleCheck, error: CircleAlert, info: Info, warning: TriangleAlert };
</script>

<div class="toaster" aria-live="polite" aria-relevant="additions">
  {#each toast.items as item (item.id)}
    {@const Icon = icons[item.kind]}
    <div class="toast {item.kind}" role={item.kind === 'error' ? 'alert' : 'status'} animate:flip={{ duration: 180 }} in:fly={{ y: 12, duration: 200 }} out:fade={{ duration: 140 }}>
      <span class="ic"><Icon size={18} /></span>
      <div class="txt">
        <span class="msg">{item.message}</span>
        {#if item.description}<span class="desc">{item.description}</span>{/if}
      </div>
      {#if item.action}
        <button type="button" class="act" onclick={() => { item.action?.run(); toast.dismiss(item.id); }}>{item.action.label}</button>
      {/if}
      <button type="button" class="x" aria-label={t('ui.close')} onclick={() => toast.dismiss(item.id)}><X size={14} /></button>
    </div>
  {/each}
</div>

<style>
  .toaster {
    position: fixed; z-index: var(--z-toast);
    right: var(--space-5); bottom: var(--space-5);
    display: flex; flex-direction: column; gap: var(--space-2); align-items: flex-end;
    pointer-events: none;
    max-width: calc(100vw - 32px);
  }
  @media (max-width: 760px) {
    .toaster { left: var(--space-3); right: var(--space-3); bottom: calc(var(--mobile-nav-h) + var(--space-3) + env(safe-area-inset-bottom)); align-items: stretch; }
  }
  .toast {
    pointer-events: auto;
    display: flex; align-items: flex-start; gap: var(--space-2_5);
    min-width: 280px; max-width: 420px;
    padding: var(--space-3) var(--space-3) var(--space-3) var(--space-3);
    background: var(--bg-elevated);
    color: var(--text);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    box-shadow: var(--shadow-lg);
  }
  .ic { display: inline-flex; margin-top: 1px; }
  .success .ic { color: var(--success); }
  .error .ic { color: var(--danger); }
  .warning .ic { color: var(--warning); }
  .info .ic { color: var(--brand); }
  .txt { flex: 1; display: flex; flex-direction: column; gap: var(--space-0_5); min-width: 0; }
  .msg { font-size: var(--text-base); font-weight: var(--weight-semibold); }
  .desc { font-size: var(--text-sm); color: var(--text-2); }
  .act { border: 0; background: var(--brand-soft); color: var(--brand); font-weight: var(--weight-semibold); font-size: var(--text-sm); padding: var(--space-1) var(--space-2_5); border-radius: var(--radius-pill); align-self: center; }
  .act:hover { background: var(--brand-tint); }
  .act:focus-visible, .x:focus-visible { outline: none; box-shadow: var(--ring); }
  .x { border: 0; background: transparent; color: var(--text-3); padding: var(--space-0_5); border-radius: var(--radius-xs); display: inline-flex; }
  .x:hover { color: var(--text); }
</style>
